import { z } from "zod";

export const envSchema = z.object({
	VITE_APP_NAME: z.string().default("Excel Center"),
	VITE_APP_SLUG: z.string().default("excel-center"),
	VITE_SUPABASE_URL: z.url(),
	VITE_SUPABASE_ANON_KEY: z.string().min(1),
});

const _env = envSchema.parse(import.meta.env);

export const env = {
	MODE: import.meta.env.MODE,
	APP_NAME: _env.VITE_APP_NAME,
	APP_SLUG: _env.VITE_APP_SLUG,
	SUPABASE_URL: _env.VITE_SUPABASE_URL,
	SUPABASE_ANON_KEY: _env.VITE_SUPABASE_ANON_KEY,
} as const;
